// Poll categories with icons
export interface CategoryInfo {
  name: string;
  icon: string;
  description: string;
}

export const CATEGORIES: Record<string, CategoryInfo> = {
  General: {
    name: 'General',
    icon: '🎯',
    description: 'Uncategorized, random questions',
  },
  Sports: {
    name: 'Sports',
    icon: '⚽',
    description: 'Sports, teams, athletes, games',
  },
  Entertainment: {
    name: 'Entertainment',
    icon: '🎬',
    description: 'Movies, TV shows, music, celebrities',
  },
  Technology: {
    name: 'Technology',
    icon: '💻',
    description: 'Tech products, software, gadgets, coding',
  },
  Politics: {
    name: 'Politics',
    icon: '🏛️',
    description: 'Political topics, current events, policy',
  },
  'Food & Drink': {
    name: 'Food & Drink',
    icon: '🍕',
    description: 'Restaurants, recipes, cuisine, drinks',
  },
  Lifestyle: {
    name: 'Lifestyle',
    icon: '✨',
    description: 'Fashion, fitness, wellness, hobbies',
  },
  Gaming: {
    name: 'Gaming',
    icon: '🎮',
    description: 'Video games, esports, gaming culture',
  },
  Science: {
    name: 'Science',
    icon: '🔬',
    description: 'Science, nature, space, education',
  },
  Business: {
    name: 'Business',
    icon: '💼',
    description: 'Startups, companies, finance, careers',
  },
};

export const CATEGORY_NAMES = Object.keys(CATEGORIES);

export function getCategoryIcon(category: string): string {
  return CATEGORIES[category]?.icon || '🎯';
}

export function getCategoryName(category: string): string {
  return CATEGORIES[category]?.name || 'General';
}
